/* Coupon counter roll: starts a few above the target and ticks DOWN one at a
   time to land on the current number (e.g. 20 -> 19 -> 18 -> 17 -> 16 -> 15).
   Server renders the final number as text; this only animates the lead-in.
   Falls back to the plain number when disabled, reduced-motion, or no JS. */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animate(el) {
    if (el.dataset.rolled) return;
    el.dataset.rolled = '1';

    var target = parseInt((el.getAttribute('data-count') || el.textContent || '').trim(), 10);
    if (isNaN(target)) return;
    if (el.dataset.animate === 'false' || REDUCED) { el.textContent = String(target); return; }

    var offset = parseInt(el.dataset.offset || '5', 10);
    var stepMs = parseInt(el.dataset.step || '90', 10);
    var current = target + offset;
    if (current <= target) { el.textContent = String(target); return; }

    el.textContent = String(current);
    var timer = window.setInterval(function () {
      current -= 1;
      if (current <= target) {
        el.textContent = String(target);
        window.clearInterval(timer);
        el.classList.add('cb-landed');
      } else {
        el.textContent = String(current);
      }
    }, stepMs);
  }

  function boot() {
    var nodes = document.querySelectorAll('.coupon-banner__count[data-count]');
    if (!nodes.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(animate);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
